import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { FormGroup, Text } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'

import { saveExperienceAddress, saveExperience } from '../../_utils'


class Where extends Component {
    
    handleChange(target) {

        if(target.name === 'placeType') {
            this.props.setData({
                experience: {
                    ...this.props.data.experience,
                    [target.name]: target.checked ? 'outdoor' : 'indoor'
                }
            }, () => {
                this.handleChanged(target)
            })
        } else {   
            let address = this.props.data.address || {}
            address[target.name] = target.value
            
            this.props.setData({
                address
            }, () => {
                if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
                this.handleChanged(target)
            })
        }
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        if(this.validateFields[name] && !this.validateFields[name]()) return;

        const form = {}

        let async = null
        if(name === 'placeType') {
            form['placeType'] = this.props.data.experience.placeType
            async = saveExperience(this.props.token, form)
            .then(resp => {})

        } else {
            form[name] = this.props.data.address[name]
            async = saveExperienceAddress(this.props.token, form)
            .then(resp => {})
        }

        if(this.props.async) this.props.async(async)
    }

    validateFields = {
        // bringWhat: () => true
    }

    validate() {
        let valid = true

        Object.keys(this.validateFields).forEach(item => {
            valid = this.validateFields[item]() ? valid : false
        })

        return valid
    }

    render() {
        return (
            <ContentInfo
                title='Endereço completo'
                description='Informe com detalhes o endereço da sua academia.'
                steps={this.props.steps}
                >

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Endereço completo da sua academia
                            </Display>
                        </FormGroup>
                    </Col>
                    <Col size='12'>
                        <FormGroup>
                            <Text
                                label='Nome do local'
                                name="meetingPoint"
                                value={this.props.data.address ? this.props.data.address.meetingPoint : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='6'>
                        <FormGroup>
                            <Text
                                label='CEP'
                                name="zip"
                                value={this.props.data.address ? this.props.data.address.zip : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12 12 6'>
                        <FormGroup>
                            <Text
                                label='País'
                                name="country"
                                value={this.props.data.address ? this.props.data.address.country : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>

                    <Col size='12 12 6'>
                        <FormGroup>
                            <Text
                                label='Estado'
                                name="state"
                                value={this.props.data.address ? this.props.data.address.state : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12 12 6'>
                        <FormGroup>
                            <Text
                                label='Cidade'
                                name="city"
                                value={this.props.data.address ? this.props.data.address.city : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>

                    <Col size='12 12 6'>
                        <FormGroup>
                            <Text
                                label='Bairro'
                                name="neighborhood"
                                value={this.props.data.address ? this.props.data.address.neighborhood : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='8 8 8 10'>
                        <FormGroup>
                            <Text
                                label='Endereço'
                                name="address"
                                value={this.props.data.address ? this.props.data.address.address : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>

                    <Col size='4 4 4 2'>
                        <FormGroup>
                            <Text
                                label='Número'
                                name="number"
                                value={this.props.data.address ? this.props.data.address.number : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12s'>
                        <FormGroup>
                            <Text
                                label='Complemento'
                                name="complement"
                                value={this.props.data.address ? this.props.data.address.complement : ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>
                
            </ContentInfo>
        )
    }

}

export default Where


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/Steps/Where/index.js